import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/productUnavailable.svg';

export const IconProductUnavailable = createIconComponent(Icon);
